export enum ShareTypeEnumFR {
  FCPI = 'FCPI',
  SCPI = 'SCPI',
  FIP = 'FIP',
  GFI = 'GFI',
  FONDS_FORESTIER = 'FONDS_FORESTIER',
  FCPR = 'FCPR',
}

export enum ShareTypeEnum {
  FCPI = 'FCPI',
  SCPI = 'SCPI',
  FIP = 'FIP',
  GFI = 'GFI',
  FORESTRY_FUND = 'FORESTRY_FUND',
  FCPR = 'FCPR',
}

export const translateShareTypeEnum = (st: ShareTypeEnumFR): ShareTypeEnum => {
  switch (st) {
    case ShareTypeEnumFR.FCPI:
      return ShareTypeEnum.FCPI;
    case ShareTypeEnumFR.SCPI:
      return ShareTypeEnum.SCPI;
    case ShareTypeEnumFR.FIP:
      return ShareTypeEnum.FIP;
    case ShareTypeEnumFR.GFI:
      return ShareTypeEnum.GFI;
    case ShareTypeEnumFR.FONDS_FORESTIER:
      return ShareTypeEnum.FORESTRY_FUND;
    case ShareTypeEnumFR.FCPR:
      return ShareTypeEnum.FCPR;
  }
};
